export default theme => ({
  wrapper: {
    paddingBottom: theme.spacing.unit
  },
  container: {
    background: '#4a0000',
    border: '1px solid #1d2c4c',
    '-moz-border-radius': '2px',
    '-webkit-border-radius': '2px',
    borderRadius: '2px',
    color: '#fff',
  },
  list: {
    borderRight: '1px solid #444',
    display: 'flex',
    flexDirection: 'column',
    // alignContent: 'space-between',
    // justifyContent: 'space-between',
    height: '100%',
  }
})

